import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component
export default class FieldValidatorByRules extends Vue {

	@Prop(String)
	readonly mask!: string | undefined;

	@Prop({ type: Array, default: () => [] })
	readonly rules!: Array<(v: string | null) => boolean>

	@PropSync('validated', { type: Boolean, default: false })
	localValidated!: boolean

	required!: boolean

	invalidFromRules: boolean = false

	validateByRules(v: string | null): boolean {
		// TODO Replace to FieldValidator.validateFieldByRules()
		if (!v && !this.required) return this.setValidated(true);

		for (let i = 0; i < this.rules.length; i++) {
			if (!this.rules[i](v)) return this.setValidated(false);
		}

		return this.setValidated(true);
	}

	setValidated(v: boolean): boolean {
		this.invalidFromRules = !v;
		this.localValidated = v;

		return this.localValidated;
	}

	get showError(): boolean {
		return !this.localValidated && this.invalidFromRules;
	}

}